import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IInsuredPersonCaseState, IPolicy, TError } from './types/InsuredPersonCase-interface'

const InsuredPersonCaseState = (state: RootState): IInsuredPersonCaseState => state.policyCase

export const InsuredPerson = createSelector(
    [InsuredPersonCaseState],
    (state): IPolicy => state.Policy,
)
export const LoadingPolicy = createSelector(
    [InsuredPersonCaseState],
    (state): boolean => state.isLoadingPolicy,
)
export const ErrorPolicy = createSelector(
    [InsuredPersonCaseState],
    (state): TError => state.errorPolicy,
)

export const LastFetchPolicy = createSelector(
    [InsuredPersonCaseState],
    (state): null | number => state.lastFetchTime,
)
export const Download = createSelector(
    [InsuredPersonCaseState],
    (state): boolean => state.isDownload,
)
export const ErrorDownload = createSelector(
    [InsuredPersonCaseState],
    (state): TError  => state.errorDownload,
)
export const FileData = createSelector(
    [InsuredPersonCaseState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [InsuredPersonCaseState],
    (state): string => state.FileName,
)